import type { Permission } from '@hoopoe/shared';
import {
  Banknote,
  BookOpen,
  CalendarRange,
  FileUp,
  FolderKanban,
  FolderSearch,
  Home,
  Inbox,
  Library,
  type LucideIcon,
  Map as MapIcon,
  MessagesSquare,
  Network,
  Orbit,
  ScrollText,
  Settings,
} from 'lucide-react';

export type NavItem = { to: string; label: string; icon: LucideIcon; permission?: Permission };

export const NAV: NavItem[] = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/upload', label: 'Upload', icon: FileUp, permission: 'content.write' },
  { to: '/review', label: 'Review', icon: Inbox },
  { to: '/directory', label: 'Directory', icon: FolderSearch },
  { to: '/library', label: 'Library', icon: Library },
  { to: '/cases', label: 'Cases', icon: FolderKanban },
  { to: '/graph', label: 'Graph', icon: Network },
  { to: '/timeline', label: 'Timeline', icon: CalendarRange },
  { to: '/map', label: 'Map', icon: MapIcon },
  { to: '/clusters', label: 'Clusters', icon: Orbit },
  { to: '/flows', label: 'Money flows', icon: Banknote },
  { to: '/reports', label: 'Reports', icon: ScrollText },
  { to: '/chat', label: 'Chat', icon: MessagesSquare },
  { to: '/onboarding', label: 'Onboarding', icon: BookOpen },
  { to: '/admin', label: 'Admin', icon: Settings, permission: 'admin.manage' },
];
